import React from "react";
import Hero from "../components/Hero";
import Service from "../components/Service";
import Feature from "../components/Feature";

const Home = () => {
   return (
      <>
         <Hero />
         <Service />
         <Feature />
      </>
   );
};

export default Home;
